import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface OrderDeliveryDateModalProps {
  isOpen: boolean;
  toggle: () => void;
  selectedDeliveryDate: string; // ISO string
  setSelectedDeliveryDate: (date: string) => void;
  handleDeliveryDateUpdate: () => void;
}

const OrderDeliveryDateUpdate: React.FC<OrderDeliveryDateModalProps> = ({
  isOpen,
  toggle,
  selectedDeliveryDate,
  setSelectedDeliveryDate,
  handleDeliveryDateUpdate,
}) => {
  console.log("Modal isOpen:", isOpen);
  console.log("Selected Delivery Date (raw):", selectedDeliveryDate);

  useEffect(() => {
    console.log("OrderDeliveryDateUpdate mounted");
    return () => {
      console.log("OrderDeliveryDateUpdate unmounted");
    };
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("New input value:", e.target.value);
    setSelectedDeliveryDate(e.target.value);
  };

  const handleSaveClick = () => {
    console.log("Save button clicked");
    handleDeliveryDateUpdate();
  };

  const handleDiscardClick = () => {
    console.log("Discard button clicked");
    toggle();
  };

  // ✅ Format ISO string to YYYY-MM-DD for input[type="date"]
  const formattedDate = selectedDeliveryDate
    ? new Date(selectedDeliveryDate).toISOString().split("T")[0]
    : "";

  console.log("Formatted Delivery Date (for input):", formattedDate);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Delivery Date</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="form-label" htmlFor="delivery-date">
            Select Delivery Date
          </label>
          <input
            type="date"
            className="form-control"
            id="delivery-date"
            name="deliveryDate"
            onChange={handleInputChange}
            value={formattedDate}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleDiscardClick}>
          Discard
        </Button>
        <Button color="primary" onClick={handleSaveClick}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrderDeliveryDateUpdate;
